import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ logout }) {
  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  // to-do  add redirect uri to the new layers when legacy login page is gone https://learn.microsoft.com/en-us/entra/identity-platform/scenario-spa-sign-in?tabs=react
  useEffect(() => {
    // Platform logout first: it fires the LAYI logout request and drops the session cookie before
    // MSAL starts navigating away to Entra.
    logout()
    if (isAuthenticated) {
      instance.logoutRedirect({
        postLogoutRedirectUri: '/',
        mainWindowRedirectUri: '/'
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return !isAuthenticated ? <Navigate to="/" replace /> : null
}
